var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMinusIcon = function SvgMinusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 2.058
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18775",
    d: "M0 2.058V0h14v2.058Z",
    fill: "currentColor"
  })));
};
export default SvgMinusIcon;